import { Form, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { lowerCase } from "lodash";
import { useSelector } from "react-redux";

import { baseUnitCreate, customStyles } from "./createOrderSale.constants";
import { ReactComponent as DeleteIcon } from "@/assets/images/desktop/closemin.svg";
import { ReactComponent as HelpIcon } from "@/assets/images/desktop/help.svg";

import classes from "./createOrderSale.module.scss";

import { integerValidate, formatMilesDecimalNew, decimalValidateNew, formatMiles } from "@/services/Utils";
import CreateOrderSaleSuggestion from "./CreateOrderSaleSuggestion";
import CustomDateInput from "@/components/desktop/form/input/input-date/CustomDateInput";

import { NoOptionsMessage, SingleValue } from "@/components/ReactSelect/NoOptions";
import ProductInput from "@/components/Form/Inputs/Product/ProductInput";

const CreateOrderSaleTableItem = ({
	data,
	setData,
	products,
	products_generic,
	changeProduct,
	changeQuantity,
	changeTextProduct,
	changeCas,
	changeContainerContent,
	changeUnitMeasurement,
	changePrice,
	changeExpirationDate,
	changeTypeProduct,
	changeLotProduction,
	changeProductGeneric,
	changeQuantityLot,
}) => {
	const { user } = useSelector((state) => state.auth);
	const tools = user ? user.tools : [];

	return (
		<Table className={classes.tableDetail}>
			<thead className={classes.tableDetailHead}>
				<tr>
					<th className={classes.headTh} style={{ width: "18%" }}>
						Producto <br />
						<small>Ingrese al menos 3 letras para buscar.</small>
					</th>
					{user && user.customer && user.customer.id === 15 && (
						<th className={classes.headTh} style={{ width: "10%" }}>
							CAS
						</th>
					)}
					<th className={classes.headTh} style={{ width: "7%" }}>
						Cant. Envases
					</th>
					<th className={classes.headTh} style={{ width: "7%" }}>
						Contenido <br />
						por Envase
					</th>
					<th className={classes.headTh} style={{ width: "8%" }}>
						U.M
					</th>
					<th className={classes.headTh} style={{ width: "8%" }}>
						Precio <br />
						Total Neto
					</th>
					<th className={classes.headTh} style={{ width: "8%" }}>
						Fecha <br />
						Vencimiento
					</th>
					{tools.find((t) => t.id === 17) && (
						<th className={classes.headTh} style={{ width: "10%" }}>
							Cant. Envases <br />
							por Lote
						</th>
					)}
					<th className={classes.headTh} style={{ width: "14%" }}>
						Genérico
					</th>
					<th className={classes.headTh} style={{ width: "8%" }}>
						Lote de <br />
						Producción
					</th>
					<th className={classes.headTh} style={{ width: "10%" }}>
						Observación
					</th>
					<th className={classes.headTh} style={{ width: "5%" }}></th>
				</tr>
			</thead>
			<tbody>
				{data &&
					data.items &&
					data.items.map((item, i) => {
						return (
							<tr key={i}>
								{/* Product */}
								<td>
									<div style={{ display: "flex" }}>
										<div style={{ width: item.suggestions && item.suggestions.length !== 0 ? "90%" : "100%" }}>
											<CreatableSelect
												value={products && products.filter((p) => p.value === item.product_id)}
												options={
													item.text_product && item.text_product.length > 1
														? products && products.filter((p) => lowerCase(p.label).includes(lowerCase(item.text_product)))
														: []
												}
												menuPortalTarget={document.body}
												components={{
													NoOptionsMessage,
													SingleValue,
													Option: ProductInput,
												}}
												formatCreateLabel={(value) => {
													return `Crear ${value}`;
												}}
												placeholder={""}
												isClearable
												onInputChange={(value) => changeTextProduct(i, value)}
												onChange={(opt, meta) => {
													changeProduct(i, opt, meta);
												}}
												menuPlacement="top"
											/>
										</div>
										{item.suggestions && item.suggestions.length !== 0 && (
											<CreateOrderSaleSuggestion suggestions={item.suggestions} index={i} data={data} setData={setData} />
										)}
									</div>
								</td>

								{/* CAS */}
								{user && user.customer && user.customer.id === 15 && (
									<td>
										<Form.Control
											className={classes.input}
											type="text"
											value={item && item.cas ? item.cas : ""}
											onChange={(e) => changeCas(i, e.target.value)}
										/>
									</td>
								)}
								{/* Quantity */}
								<td>
									<div>
										<Form.Control
											className={classes.input}
											style={{
												textAlign: "right",
											}}
											type="text"
											value={item && item.quantity ? formatMiles(item.quantity) : ""}
											onChange={(e) => changeQuantity(i, e.target.value)}
											readOnly={item && item.ids_inventories}
											onKeyDown={integerValidate}
										/>
									</div>
								</td>
								{/* Content */}
								<td>
									<Form.Control
										className={classes.input}
										style={{
											textAlign: "right",
										}}
										type="text"
										value={item && item.container_content ? formatMilesDecimalNew(item.container_content) : ""}
										onChange={(e) => changeContainerContent(i, e.target.value)}
										onKeyDown={decimalValidateNew}
										readOnly={item.unit_measurement === "u" ? true : false}
									/>
								</td>
								{/* Unit */}
								<td>
									<Select
										value={
											Number(item.value_unit_measurement) && item.units_enabled
												? item.units_enabled.filter((b) => Number(b.value) === Number(item.value_unit_measurement))
												: baseUnitCreate.filter((b) => b.value === item.value_unit_measurement)
										}
										placeholder={<div></div>}
										options={item.units_enabled ? item.units_enabled : baseUnitCreate}
										onChange={(value) => changeUnitMeasurement(i, value.value)}
										menuPortalTarget={document.body}
										components={{ NoOptionsMessage }}
										menuPlacement="top"
									/>
								</td>
								{/* Price Total */}
								<td>
									<Form.Control
										className={classes.input}
										type="text"
										style={{
											textAlign: "right",
										}}
										value={item && item.price_total ? formatMilesDecimalNew(item.price_total) : ""}
										onChange={(e) => changePrice(i, e.target.value)}
										onKeyDown={decimalValidateNew}
									/>
								</td>
								{/* Expiration Date */}
								<td>
									<CustomDateInput index={i} value={item.expiration_date} setValue={changeExpirationDate} />
								</td>
								{/* Lot */}
								{tools.find((t) => t.id === 17) && (
									<td>
										{item && item.has_lot && item.has_lot !== "" ? (
											<OverlayTrigger overlay={<Tooltip>{item.lot_id}</Tooltip>}>
												<div className={classes.lotAssigned}>Lote asignado</div>
											</OverlayTrigger>
										) : (
											<Form.Control
												className={classes.input}
												type="text"
												style={{
													textAlign: "right",
												}}
												value={item && item.quantity_lot ? formatMiles(item.quantity_lot) : ""}
												onChange={(e) => changeQuantityLot(i, e.target.value)}
												onKeyDown={integerValidate}
											/>
										)}
									</td>
								)}
								{/* Generic */}
								<td>
									<CreatableSelect
										value={
											Array.isArray(products_generic)
												? (products_generic.find((pg) => String(pg.value) === String(item.save_as)) ?? null)
												: null
										}
										options={
											products_generic.length > 0 ? products_generic.filter((pc) => Number(pc.estate_id) === Number(data.estate_id)) : []
										}
										menuPortalTarget={document.body}
										styles={customStyles}
										components={{ NoOptionsMessage, SingleValue }}
										formatCreateLabel={(value) => {
											return `Crear ${value}`;
										}}
										placeholder={""}
										isClearable
										isDisabled={item.ids_inventories && item.save_as ? true : false}
										onChange={(opt, meta) => {
											changeProductGeneric(i, opt, meta);
										}}
										menuPlacement="top"
									/>
								</td>
								{/* Lot Production */}
								<td>
									<Form.Control
										className={classes.input}
										type="text"
										value={item && item.lot_production}
										onChange={(e) => changeLotProduction(i, e.target.value)}
									/>
								</td>
								{/* Observation */}
								<td>
									<Form.Control
										className={classes.input}
										type="text"
										value={item && item.type_product}
										onChange={(e) => changeTypeProduct(i, e.target.value)}
									/>
								</td>
								{/* Actions */}
								{item && (
									<td>
										<div className={classes.listButtons}>
											{Object.prototype.hasOwnProperty.call(item, "order_delivery_id") && item.order_delivery_id && (
												<OverlayTrigger
													overlay={<Tooltip>{`Producto asociado a la guía de despacho n°${item.order_delivery}.`}</Tooltip>}
												>
													<HelpIcon className={classes.button} style={{ fill: "#0c60b3" }} />
												</OverlayTrigger>
											)}
											<OverlayTrigger overlay={<Tooltip>Eliminar Producto</Tooltip>}>
												<DeleteIcon
													className={classes.button}
													onClick={() => {
														let newItems = [...data.items];
														newItems.splice(i, 1);
														setData({
															...data,
															items: newItems,
														});
													}}
												/>
											</OverlayTrigger>
										</div>
									</td>
								)}
							</tr>
						);
					})}
			</tbody>
		</Table>
	);
};

export default CreateOrderSaleTableItem;
